import React, { useCallback, forwardRef, useImperativeHandle, useState } from 'react';
import Select from 'react-select';
import axios from 'axios';
import debounce from 'lodash/debounce';
import config from '../../config';
import { v4 as uuidv4 } from 'uuid';
import { alertconfirmation } from '../../alerts/Alerts';

const DirectBillPlanCoverageComponent = forwardRef(({ caseId, planId, planName, planRateType, renewalCase, isRatesChanging, isRenewal, selectOptions, isDisableForUsers, initialFormValues = {}, onError = () => { } }, ref) => {
  const fetchUrl = `${config.API_URL}/DirectBill${planName}CoverageRates/ByCOBRA${planName}PlanId/${planId}`;
  const updateUrl = `${config.API_URL}/DirectBill${planName}CoverageRates`;
  const addUrl = `${config.API_URL}/DirectBill${planName}CoverageRates`;
  const deleteUrl = `${config.API_URL}/DirectBill${planName}CoverageRates`;

  const [coverageRates, setCoverageRates] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);
  const [validationErrors, setValidationErrors] = useState([]);

  const fetchCoverageRates = async () => {
    try {
      const response = await axios.get(fetchUrl);
      setCoverageRates(response.data || []);
    } catch (error) {
      setError('Error fetching plans.');
      onError(error);
    } finally {
      setLoading(false);
    }
  };
  
  React.useEffect(() => {
    fetchCoverageRates();
  }, []);

 

  React.useEffect(() => {
    fetchCoverageRates();
  }, []);

 

  

  const validateField = (field, value) => {
    let errorMessage = '';
  
    if (isRatesChanging === 'true') {
      
      if (field === 'coverageLevelName' && !value) {
        errorMessage = 'Coverage Level Name is required';
        return errorMessage;
      }
  
      const numericValue = parseFloat(value);
      if (field === 'futureRate') {
        if (planRateType !== "UnitBased" && (isNaN(numericValue) || numericValue === 0)) {
          errorMessage = 'Future rate must be a valid number greater than 0.';
        } else if (numericValue < 0) {
          errorMessage = 'Future rate cannot be negative.';
        } else if (numericValue > 1000000) {
          errorMessage = 'Future rate is too large. Please enter a number less than 1,000,000.';
        }
      }

      // if (field === 'currentRate' && planRateType === "UnitBased") {
      //   if (isNaN(numericValue) ) {
      //     errorMessage = 'Current rate must be a valid number greater than 0.';
      //   } else if (numericValue < 0) {
      //     errorMessage = 'Current rate cannot be negative.';
      //   } else if (numericValue > 1000000) {
      //     errorMessage = 'Current rate is too large. Please enter a number less than 1,000,000.';
      //   }
      // }
      
    }
  
    return errorMessage;
  };
  
  
  

  const validateAll = () => {
    let allValid = true;
    let updatedErrors = { ...validationErrors };

    coverageRates.forEach((rate, index) => {
      ['coverageLevelName', 'currentRate', 'futureRate'].forEach((field) => {
        const fieldError = validateField(field, rate[field]);
        if (fieldError) {
          allValid = false;
          updatedErrors[index] = {
            ...updatedErrors[index],
            [field]: fieldError,
          };
        }
      });
    });
    
    setValidationErrors(updatedErrors);
    return allValid;
  };

  const debouncedUpdate = useCallback(
    debounce(async (fieldName, value, planId) => {
      try {
        const patchDocument = [{ op: 'replace', path: `/${fieldName}`, value }];
        const url = `${updateUrl}/${planId}`;
        await axios.patch(url, patchDocument);
        if(planRateType == 'UnitBased' && fieldName == 'futureRate'){
          const patchDocument = [{ op: 'replace', path: 'currentRate', value }];
        const url = `${updateUrl}/${planId}`;
        await axios.patch(url, patchDocument);
        }
      } catch (error) {
        console.error('Error updating field:', error);
        onError(error);
      }
    }, 500),
    [updateUrl, onError]
  );

  React.useEffect(() => {
    const updateFutureRates = async () => {
      if (planRateType === "UnitBased" && isRenewal) {
        const updatePromises = coverageRates.map((rate) => {
          if (rate.currentRate !== undefined) {
            const patchDocument = [{ op: 'replace', path: '/futureRate', value: rate.currentRate }];
            const url = `${updateUrl}/${rate.id}`;
            return axios.patch(url, patchDocument);
          }
          return null;
        }).filter(Boolean); // Filter out null values
  
        try {
          await Promise.all(updatePromises);
          console.log('All future rates updated successfully');
        } catch (error) {
          console.error('Error updating future rates:', error);
          onError(error);
        }
      }
    };
  
    updateFutureRates();
  }, [planRateType, coverageRates, updateUrl, isRenewal]);
  

  const handleInputChange = (index, field, value) => {
    const updatedCoverageRates = [...coverageRates];
    updatedCoverageRates[index] = { ...updatedCoverageRates[index], [field]: value };
  
    const fieldError = validateField(field, value);
  
    
    const updatedErrors = Array.isArray(validationErrors) ? [...validationErrors] : [];
  
    if (fieldError) {
      
      updatedErrors[index] = { ...(updatedErrors[index] || {}), [field]: fieldError };
    } else {
      
      if (updatedErrors[index]) {
        delete updatedErrors[index][field];
        
        if (Object.keys(updatedErrors[index]).length === 0) {
          updatedErrors.splice(index, 1);
        }
      }
    }
  
    setValidationErrors(updatedErrors);
    setCoverageRates(updatedCoverageRates);
    debouncedUpdate(field, value, updatedCoverageRates[index].id);
  };

  const updateCoverageRate = async (fieldName, value, planId) => {
    try {
      const patchDocument = [{ op: 'replace', path: `/${fieldName}`, value }];
      const url = `${updateUrl}/${planId}`;
      await axios.patch(url, patchDocument);
      
      
    } catch (error) {
      console.error('Error updating field:', error);
      onError(error);
    }
  };
  
  const handleRatesToggleChange = () => {
    const updatedCoverageRates = coverageRates.map(rate => {
      const updatedCoverageRate = { ...rate };
      updatedCoverageRate.futureRate =  isRatesChanging === 'true' ? rate.currentRate : '';
      // if (updatedCoverageRate.currentRate) {
      //   updatedCoverageRate.futureRate = updatedCoverageRate.currentRate;
      // }
      return updatedCoverageRate;
    }); 
  
    // Update the local state
    setCoverageRates(updatedCoverageRates);

    const updatedErrors = Array.isArray(validationErrors) ? validationErrors.map((error, index) => {
      const updatedError = { ...error };
      
      
      if (isRatesChanging === 'false' && updatedError.futureRate) {
        delete updatedError.futureRate;
      }
  
      
      if (Object.keys(updatedError).length === 0) {
        return null; 
      }
  
      return updatedError;
    }).filter(Boolean): []; 
  
    
    setValidationErrors(updatedErrors);
    
  
    // Directly update futureRate for each coverage rate without debouncing
    updatedCoverageRates.forEach(({ futureRate, id }) => {
      updateCoverageRate("futureRate", futureRate, id);
    });
  };

  const handleRateTypeChange = () => {
    const updatedCoverageRates = coverageRates.map(rate => {
      const updatedCoverageRate = { ...rate };
      updatedCoverageRate.currentRate = rate.futureRate || '';
      // if (updatedCoverageRate.currentRate) {
      //   updatedCoverageRate.futureRate = updatedCoverageRate.currentRate;
      // }
      return updatedCoverageRate;
    }); 
  
    // Update the local state
    setCoverageRates(updatedCoverageRates);

    const updatedErrors = Array.isArray(validationErrors) ? validationErrors.map((error, index) => {
      const updatedError = { ...error };
      
      
      if (planRateType === 'UnitBased' && updatedError.currentRate) {
        delete updatedError.currentRate;
      }
  
      
      if (Object.keys(updatedError).length === 0) {
        return null; 
      }
  
      return updatedError;
    }).filter(Boolean): []; 
  
    
    setValidationErrors(updatedErrors);
    
  
    // Directly update futureRate for each coverage rate without debouncing
    updatedCoverageRates.forEach(({ currentRate, id }) => {
      updateCoverageRate("currentRate", currentRate, id);
    });
  };
  
  

  
  
  

  const handleAddPlan = async () => {
    const randomId = uuidv4();
    try {
      const newCoverageRate = { ...initialFormValues, id: caseId+"_"+randomId, [`${planName}PlanId`]: planId };
      const response = await axios.post(addUrl, newCoverageRate);
      setCoverageRates([...coverageRates, response.data]);
    } catch (error) {
      console.error('Error adding new plan:', error);
      onError(error);
    }
  };

  const handleDeletePlan = (index) => {
    alertconfirmation(
      "Do you want to delete this coverage rate?",
      "Confirmation",
      async () => {
        try {
          const planId = coverageRates[index].id;
          await axios.delete(`${deleteUrl}/${planId}`);
          const updatedCoverages = coverageRates.filter((_, i) => i !== index);
          setCoverageRates(updatedCoverages);
        } catch (error) {
          console.error('Error deleting Coverage rate:', error);
          onError(error);
        }
      },
      () => {
        console.log("Deletion canceled.");
      }
    );
  };

  useImperativeHandle(ref, () => ({
    validateAll,
    handleRatesToggleChange,
    handleRateTypeChange
  }));


  const coverageLevelOptions = [
    { value: 'EE', label: 'EE' },
    { value: 'EEPlusChild', label: 'EE Plus Child' },
    { value: 'EEPlusChildOrChildren', label: 'EE Plus Child Or Children' },
    { value: 'EEPlusChildren', label: 'EE Plus Children' },
    { value: 'EEPlusFamily', label: 'EE Plus Family' },
    { value: 'EEPlusFourOrMoreChildren', label: 'EE Plus Four Or More Children' },
    { value: 'EEPlusFourOrMoreDependents', label: 'EE Plus Four Or More Dependents' },
    { value: 'EEPlusOneDependent', label: 'EE Plus One Dependent' },
    { value: 'EEPlusSpouse', label: 'EE Plus Spouse' },
    { value: 'EEPlusSpousePlusChild', label: 'EE Plus Spouse Plus Child' },
    { value: 'EEPlusSpousePlusFourOrMoreChildren', label: 'EE Plus Spouse Plus Four Or More Children' },
    { value: 'EEPlusSpousePlusThreeChildren', label: 'EE Plus Spouse Plus Three Children' },
    { value: 'EEPlusSpousePlusThreeOrMoreChildren', label: 'EE Plus Spouse Plus Three Or More Children' },
    { value: 'EEPlusSpousePlusTwoChildren', label: 'EE Plus Spouse Plus Two Children' },
    { value: 'EEPlusThreeChildren', label: 'EE Plus Three Children' },
    { value: 'EEPlusThreeDependents', label: 'EE Plus Three Dependents' },
    { value: 'EEPlusThreeOrMoreDependents', label: 'EE Plus Three Or More Dependents' },
    { value: 'EEPlusTwoChildren', label: 'EE Plus Two Children' },
    { value: 'EEPlusTwoDependents', label: 'EE Plus Two Dependents' },
    { value: 'EEPlusTwoOrMoreChildren', label: 'EE Plus Two Or More Children' },
    { value: 'EEPlusTwoOrMoreDependents', label: 'EE Plus Two Or More Dependents' },
    { value: 'OneOrMorePeople', label: 'One Or More People' },
    { value: 'SpouseOnly', label: 'Spouse Only' },
    { value: 'SpousePlusChild', label: 'Spouse Plus Child' },
    { value: 'SpousePlusChildOrChildren', label: 'Spouse Plus Child Or Children' },
    { value: 'SpousePlusChildren', label: 'Spouse Plus Children' },
    { value: 'SpousePlusThreeChildren', label: 'Spouse Plus Three Children' },
    { value: 'SpousePlusTwoChildren', label: 'Spouse Plus Two Children' },
    { value: 'ThreeChildren', label: 'Three Children' },
    { value: 'ThreeOrMoreChildren', label: 'Three Or More Children' },
    { value: 'TwoChildren', label: 'Two Children' },
    { value: 'ChildOnly', label: 'Child Only' },
    { value: 'ChildOrChildrenOnly', label: 'Child Or Children Only' },
    { value: 'ChildrenOnly', label: 'Children Only' }
  ]

  const relationShipsOptions = [
    { value: 'Subscriber', label: 'Subscriber' },
    { value: 'Spouse', label: 'Spouse' },
    { value: 'Child', label: 'Child' },
    { value: 'Not Applicable', label: 'Not Applicable' }
  ]

  const customStyles = (hasError) => ({
    control: (provided) => ({
        ...provided,
        borderColor: hasError ? '#dc3545' : provided.borderColor,
        '&:hover': {
            borderColor: hasError ? '#dc3545' : provided.borderColor,
        },
        boxShadow: hasError ? '0 0 10px rgba(220, 53, 69, 0.5)' : provided.boxShadow,
    }),
});



  //const isDisabled = renewalCase?.directBillSubmissionStatus === 'Submitted' || isDisableForUsers;
  const isDisabled = isDisableForUsers;

  return (
    <div id={`CoverageRates_${planId}`}>
      {coverageRates.map((rate, index) => (
        <div key={index} className="row">
          <div className="col-lg-3">
            <div className="input-group mb-2">
              <Select
                className={`flex-grow-1 ${ validationErrors[index]?.coverageLevelName ? 'is-invalid' : ''}`}
                options={planRateType === "UnitBased" ? relationShipsOptions : coverageLevelOptions }
                value={planRateType === "UnitBased" ? relationShipsOptions.find(option => option.value === rate?.coverageLevelName) : coverageLevelOptions.find(option => option.value === rate?.coverageLevelName)}
                onChange={(selectedOption) => handleInputChange(index, 'coverageLevelName', selectedOption.value)}
                isDisabled={isDisabled || (planRateType === "UnitBased" && isRenewal)}
                styles={customStyles(validationErrors[index]?.coverageLevelName)}
              />
              {validationErrors[index] && validationErrors[index].coverageLevelName && (
                <div className="invalid-feedback d-block">
                  {validationErrors[index].coverageLevelName}
                </div>
              )}
            </div>
          </div>
          {isRenewal && (
            <div className="col-lg-3">
            <div className="input-group mb-2">
              <input
                type="text"
                className={`form-control ${validationErrors[index] && validationErrors[index].currentRate ? 'is-invalid' : ''}`}
                placeholder="$0.00"
                name='currentRate'
                value={rate.currentRate}
                onChange={(e) => handleInputChange(index, 'currentRate', e.target.value)}
                disabled={isDisabled || (isRenewal && planRateType !== "UnitBased")}
              />
              {validationErrors[index] && validationErrors[index].currentRate && (
                <div className="invalid-feedback d-block">
                  {validationErrors[index].currentRate}
                </div>
              )}
            </div>
          </div>
          )}

          {(planRateType !== "UnitBased" && isRenewal) ? (
             <div className="col-lg-3">
             <div className="input-group mb-2">
               <input
                 type="text"
                 className={`form-control ${validationErrors[index] && validationErrors[index].futureRate ? 'is-invalid' : ''}`}
                 placeholder="$0.00"
                 name="futureRate"
                 value={isRatesChanging === 'true' ? rate.futureRate : rate.currentRate }
                 onChange={(e) => handleInputChange(index, 'futureRate', e.target.value)}
                 disabled={isDisabled || (isRenewal && isRatesChanging !== 'true')}
               />
               {validationErrors[index] && validationErrors[index].futureRate && (
                 <div className="invalid-feedback d-block">
                   {validationErrors[index].futureRate}
                 </div>
               )}
             </div>
           </div>
          ):(!isRenewal ? (
            <div className="col-lg-3">
             <div className="input-group mb-2">
               <input
                 type="text"
                 className={`form-control ${validationErrors[index] && validationErrors[index].futureRate ? 'is-invalid' : ''}`}
                 placeholder="$0.00"
                 name="futureRate"
                 value={isRatesChanging === 'true' ? rate.futureRate : rate.currentRate }
                 onChange={(e) => handleInputChange(index, 'futureRate', e.target.value)}
                 disabled={isDisabled || (isRenewal && isRatesChanging !== 'true')}
               />
               {validationErrors[index] && validationErrors[index].futureRate && (
                 <div className="invalid-feedback d-block">
                   {validationErrors[index].futureRate}
                 </div>
               )}
             </div>
           </div>
          ):(''))}


          
         
          <div className="col-lg-3">
            {coverageRates.length > 2 && (
              <button className="delete-coverage" disabled={isDisabled} onClick={() => handleDeletePlan(index)}>
                <span className="fa fa-trash-alt me-1" id="delete"></span>
              </button>
              
            )}
            {(planRateType !== "UnitBased" && (isRenewal && isRatesChanging === 'true')) ? (
              <>
              
              {  index === coverageRates.length - 1 && (
              <button type="button" className="add-coverage ms-4" disabled={isDisabled} onClick={handleAddPlan}>
                 <i className="fa fa-plus"></i>
              </button>
            )}
              </>
            ) :((!isRenewal && isRatesChanging === 'true')?(
              <>
              
              {  index === coverageRates.length - 1 && (
              <button type="button" className="add-coverage ms-4" disabled={isDisabled} onClick={handleAddPlan}>
                <i className="fa fa-plus"></i>
              </button>
            )}
              </>
            ):(''))}
            
          </div>
        </div>
      ))}
    </div>
  );
});

export default DirectBillPlanCoverageComponent;
